import { CheckCircle2, Circle, PackageCheck, Truck, Warehouse, BadgeCheck, AlertTriangle, ArrowDown, ArrowUp, HelpCircle, Lock, Unlock, Ban } from "lucide-react";
import { useLang } from "../lib/i18n";

const STATUS = {
  active: ["bg-sky-100 text-sky-900 border-sky-300", Circle],
  ready: ["bg-amber-100 text-amber-900 border-amber-300", PackageCheck],
  sent: ["bg-indigo-100 text-indigo-900 border-indigo-300", Truck],
  received: ["bg-slate-200 text-slate-900 border-slate-400", Warehouse],
  verified: ["bg-emerald-100 text-emerald-900 border-emerald-400", BadgeCheck],
  discrepancy: ["bg-red-100 text-red-900 border-red-400", AlertTriangle],
  dispatched: ["bg-teal-100 text-teal-900 border-teal-400", Truck],
  closed: ["bg-slate-100 text-slate-500 border-slate-300", Ban],
};
const CLS = {
  within: ["bg-emerald-100 text-emerald-900", CheckCircle2],
  under: ["bg-amber-100 text-amber-900", ArrowDown],
  over: ["bg-blue-100 text-blue-900", ArrowUp],
  policy_not_configured: ["bg-slate-100 text-slate-700", HelpCircle],
  unable: ["bg-slate-100 text-slate-700", HelpCircle],
};
const REL = { released: ["bg-emerald-100 text-emerald-900 border-emerald-400", Unlock], hold: ["bg-red-100 text-red-900 border-red-400", Lock], none: ["bg-slate-100 text-slate-800 border-slate-300", Ban] };

const Pill = ({ cls, Icon, text, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-bold ${cls}`}>
    <Icon size={14} strokeWidth={2.5} /> {text}
  </span>
);

export const StatusBadge = ({ status }) => {
  const { t } = useLang();
  const [c, I] = STATUS[status] || STATUS.active;
  return <Pill cls={c} Icon={I} text={t(`status_${status}`)} testid={`status-badge-${status}`} />;
};

export const ClassBadge = ({ value }) => {
  const { t } = useLang();
  if (!value) return null;
  const [c, I] = CLS[value] || CLS.unable;
  return <Pill cls={`${c} border-transparent`} Icon={I} text={t(`cls_${value}`)} testid={`class-badge-${value}`} />;
};

export const ReleaseBadge = ({ status }) => {
  const { t } = useLang();
  const s = status || "none";
  const [c, I] = REL[s] || REL.none;
  return <Pill cls={c} Icon={I} text={t(`release_${s}`)} testid={`release-badge-${s}`} />;
};
